import { render } from "./pb-resources.vue?vue&type=template&id=5e9059e7"
import script from "./pb-resources.vue?vue&type=script&lang=js"
export * from "./pb-resources.vue?vue&type=script&lang=js"

import "./pb-resources.vue?vue&type=style&index=0&id=5e9059e7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__